/*
 * Module for a conversation variable item
 */
define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "./conversationVariablesModalView",
], function (Marionette, $, Messenger, ConversationVariablesModalView) {
  var ConversationVariablesModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "conversationVariableItem";
      this.region = options.region;
      this.editMode = options.editMode;
    },
    show: function (variable) {
      this.variable = variable;
      this.variable.editMode = this.editMode;

      this.view = new ConversationVariablesModalView.conversationVariablesModalView({
        model: this.variable,
      });

      // handle bad save
      variable.on(
        "invalid",
        function (model, error) {
          this.view.clearErrors();
          if ("name" in error) {
            this.view.nameError(error["name"]);
          }
          if ("description" in error) {
            this.view.descriptionError(error["description"]);
          }
          if ("validation" in error) {
            this.view.validationError(error["validation"]);
          }
        },
        this,
      );

      this.view.on(
        "add:letter:pattern",
        function () {
          this.view.insertPatternAtCarat("{a}");
        },
        this,
      );

      this.view.on(
        "add:number:pattern",
        function () {
          this.view.insertPatternAtCarat("{d}");
        },
        this,
      );

      this.view.on(
        "add:uppercase:pattern",
        function () {
          this.view.insertPatternAtCarat("{u}");
        },
        this,
      );

      this.view.on(
        "add:lowercase:pattern",
        function () {
          this.view.insertPatternAtCarat("{l}");
        },
        this,
      );
      this.view.on(
        "done",
        function () {
          this.setVariable(function () {
            this.saveVariable();
          }, this);
        },
        this,
      );

      this.view.on(
        "cancel",
        function () {
          // if item is new, delete it
          if (variable.isNew()) {
            variable.deleteModel();
          } else {
            variable.fetch();
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );

      variable.getValidationConstraints(function (constraints) {
        this.constraints = constraints;
        // check if sub group constraint and load it if so
        if (this.constraints.get("constraintType") === 1) {
          var subGroupId = this.constraints.get("subGroupConstraint")["substGroupId"];
          var subGroup = Messenger.reqres.request("search:substitution:id", subGroupId);

          subGroup.onSynced(function () {
            this.view.setSubGroupName(subGroup.get("name"));
          }, this);
        }

        this.showRegion(this.view);
        if (this.constraints.get("constraintType") === 2) {
          this.view.setPattern(this.constraints.get("patternConstraint")["pattern"]);
          this.view.setPatternOverlay();
        }
      }, this);
    },
    setVariable: function (callback, context) {
      this.variable.set("name", this.view.getNameValue());
      this.variable.set("description", this.view.getDescriptionValue());

      var constraintType = this.view.getValidationType();
      this.constraints.setType(constraintType);

      if (constraintType == 2) {
        // Replace any tabs, newlines, or subsequent spaces with just one space
        var pattern = this.view.getPattern().trim().replace(/\s+/g, " ");
        this.constraints.set("patternConstraint", { pattern: pattern });
      }
      if (constraintType == 1) {
        var subGroups = Messenger.reqres.request(
          "search:substitution:name",
          this.view.getSubGroupName(),
        );
        subGroups.onSynced(function () {
          // Make sure there is exactly one substitution group matching provided name
          if (subGroups.length === 1) {
            // There is exactly one substitution group. Set its id on the constraint model.
            var substGroupId = subGroups.at(0).get("substId");
            this.constraints.set("subGroupConstraint", { substGroupId: substGroupId });
          } else {
            // Set subGroup to null so validation fails
            this.constraints.set("subGroupConstraint", null);
          }
          if (callback) {
            callback.apply(context);
          }
        }, this);
      } else {
        if (callback) {
          callback.apply(context);
        }
      }
    },
    saveVariable: function () {
      //save model
      if (Messenger.reqres.request("save:textbox")) {
        var _this = this;
        this.variable.saveModel({
          success: function () {
            Messenger.vent.trigger("close:modal");
          },
          error: function (model, response) {
            if (response.status === 400) {
              const errorMessage = Messenger.getErrorFromResponse(response);
              if (_this.editMode) {
                Messenger.okDialog(
                  $.t("admin.conversationVariable.updateError", { message: errorMessage }),
                );
              } else {
                Messenger.okDialog(
                  $.t("admin.conversationVariable.addError", { message: errorMessage }),
                );
              }
            } else {
              Messenger.showErrorFromResponse(response);
            }
          },
        });
      }
    },
  });

  return ConversationVariablesModalController;
});
